export const userId = (state) => state.sidebarReducer.userData.id;
